import { logger } from "@dentally/ui/logger";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleLazyLoadError = (error: any) => {
  const regex = /Loading chunk (.+?) failed/;

  const chunkError = error?.message?.match(regex);
  if (chunkError) {
    logger.error(`Chunk loading error: ${chunkError[1]}`);
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadComponentWithErrorHandling = (importFunc: () => Promise<any>) => {
  return () => {
    return importFunc().catch(handleLazyLoadError);
  };
};
